function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import axios from 'axios';
export const MARKETPLACE_URL = 'http://localhost:8081';
export const marketplaceAxios = axios.create({
    baseURL: MARKETPLACE_URL
});
export class MarketplaceHttpClient {
    constructor(){
        _define_property(this, "_api", void 0);
        _define_property(this, "get", (url, config)=>{
            return this._api.get(url, config).then((x)=>x.data);
        });
        _define_property(this, "post", (url, payload, config)=>this._api.post(url, payload, config).then((x)=>x.data));
        this._api = marketplaceAxios;
    }
}
